import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { REDUX_ROOT } from './constants';

const selectDashboardPage = state => state[REDUX_ROOT] || initialState;

export const makeSelectData = () =>
  createSelector(
    selectDashboardPage,
    state => state.data,
  );

export const makeSelectLoading = () =>
  createSelector(
    selectDashboardPage,
    state => state.loading,
  );

export const makeSelectError = () =>
  createSelector(
    selectDashboardPage,
    state => state.error,
  );
